export const MessagingServiceEvent = {
  Ready: 'MessagingService.ready',
  Started: 'MessagingService.started',
  Error: 'MessagingService.error',
  Restored: 'MessagingService.restored',
  RestoreFailed: 'MessagingService.restoreFailed',
  MessagesReceived: 'MessagingService.messagesReceived',
  ConversationCleared: 'MessagingService.conversationCleared',
  ConversationDisconnected: 'MessagingService.conversationDisconnected',
  ReadOnlyConversation: 'MessagingService.readOnlyConversation',
};

export const MessagingServiceCommand = {
  StartConversation: 'MessagingService.startConversation',
  ClearConversation: 'MessagingService.clearConversation',
  SendMessage: 'MessagingService.sendMessage',
};
